import { APIData, appFetch } from ".";

export const certificatesApi = {
  fetchPage(page: number) {
    return appFetch<APIData<Certificate[]>>("/certificates?page=" + page)
  },
};
